// const url = "https://go4robot.pl/api/v2";
// const url = "https://g4r.ang3r.pl/api/v2";
// const url = "http://localhost:8000/api/v2";
// const url = (domain) => {
//   // return "https://go4robot.pl/api/v2";
//     if (domain.hostname === 'localhost') {
//         return 'http://localhost:8000/api/v2';
//     } else {
//         return 'https://' + domain.hostname + '/api/v2';
//     }
// }
import { env } from '../utils/env';

export const apiUrl = env.API_URL;
